<template>
  <div
    v-if="fields && fields.code"
    :field="fields.code"
    :class="`wistia_embed wistia_async_${fields.code.value} seo=false`"
    style="height: 218px; width: 100%; position: relative"
  ></div>
</template>

<script>
export default {
  name: 'CIS-Wistia-Audio',
  components: {},
  props: {
    fields: {
      type: Object
    }
  },
  mounted() {
    if (this.fields.code) {
      let wistiaJsonp = document.createElement('script');
      wistiaJsonp.setAttribute(
        'src',
        'https://fast.wistia.com/embed/medias/' + this.fields.code + '.jsonp'
      );
      document.head.appendChild(wistiaJsonp);
    }

    let wistiaScript = document.createElement('script');
    wistiaScript.setAttribute('src', 'https://fast.wistia.com/assets/external/E-v1.js');
    document.head.appendChild(wistiaScript);
  }
};
</script>
